import { render } from "./VacunaPers.vue?vue&type=template&id=80a2663e&scoped=true"
import script from "./VacunaPers.vue?vue&type=script&lang=js"
export * from "./VacunaPers.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=80a2663e&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80a2663e"]])

export default __exports__